import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import oneOfArgsTruthy from "../../../common-utils/boolean/oneOfArgsTruthy.util.js";
import Box from "../../../components/atoms/Box/index.js";
import AppBar from "../../../components/molecules/AppBar/index.js";
import RenderIf from "../../../components/atoms/RenderIf/index.js";
import NavigationRail from "../../../components/molecules/NavigationRail/index.js";
import NavigationRailContentManager from "../../../components/atoms/NavigationRailContentManager/index.js";
import { Stores } from "./SdbDefault.components.js";
import withConditionalRender from "../../../components/hocs/withConditionalRender/index.js";
import titleDefaults from "../../../translate/defaults/title.defaults.js";
import searchDefaults from "../../../translate/defaults/search.defaults.js";
import logoDefaults from "../../../translate/defaults/logo.defaults.js";
import profileDefaults from "../../../translate/defaults/profile.defaults.js";
import FeatureDiscoveryClient from "../FeatureDiscovery/FeatureDiscovery.client.js";
const FeatureDiscovery = withConditionalRender(FeatureDiscoveryClient, ({ options }) => !!options);
export const SdbDefaultTemplate = ({ children, appSwitcher, logo, breadcrumbs, search, notifications, profile, actionIcons, navigationRail, hideTemplate = false, translations, featureDiscovery, }) => {
    const appBarTranslations = {
        logoTitle: logoDefaults.title,
        logoAlt: logoDefaults.alt,
        profileOf: profileDefaults.profileOf,
        applicationTitle: titleDefaults.applications,
        notificationsTitle: titleDefaults.notifications,
        profileTitle: titleDefaults.profile,
        searchPlaceholder: searchDefaults.placeholder,
        searchMoreResults: searchDefaults.moreResults,
        ...translations,
    };
    const hasAppBar = hideTemplate
        ? false
        : oneOfArgsTruthy(appSwitcher, logo, breadcrumbs, search, notifications, profile, actionIcons);
    const hasNavigationRail = hideTemplate ? false : !!navigationRail;
    const Content = hasNavigationRail ? NavigationRailContentManager : Box;
    return (_jsxs(_Fragment, { children: [_jsx(RenderIf, { condition: hasAppBar, children: _jsx(AppBar, { color: "default", variant: "elevation", logo: logo, search: search, profile: profile, appSwitcher: appSwitcher, mobileMenu: navigationRail, breadcrumbs: breadcrumbs, actionIcons: actionIcons, notifications: notifications, translations: appBarTranslations }) }), _jsx(RenderIf, { condition: hasNavigationRail, children: _jsx(NavigationRail, { clipped: hasAppBar, ...navigationRail }) }), _jsx(Content, { "data-testid": "TemplateContents", children: children }), _jsx(FeatureDiscovery, { options: hideTemplate ? undefined : featureDiscovery }), _jsx(Stores, {})] }));
};
export default SdbDefaultTemplate;
